import { createRouter, createWebHashHistory } from 'vue-router'

// Lazy-loaded: each becomes its own chunk, fetched only when actually
// navigated to, instead of bundled into the initial load. Transactions
// itself stays as the entry point's own weight since it's the default
// route almost every session hits first.
import Transactions from '@/app/views/transactions/component.vue'
const About = () => import('@/app/views/about/component.vue')
const Export = () => import('@/app/views/export/component.vue')
const Feedback = () => import('@/app/views/feedback/component.vue')
const Transaction = () => import('@/app/views/transaction/component.vue')
const Sources = () => import('@/app/views/sources/component.vue')
const SourceEdit = () => import('@/app/views/sources/edit.vue')
const Rules = () => import('@/app/views/rules/component.vue')
const RuleEdit = () => import('@/app/views/rules/edit.vue')
const StagedEdit = () => import('@/app/views/staged/edit.vue')
const Scenarios = () => import('@/app/views/scenarios/component.vue')
const Settings = () => import('@/app/views/settings/component.vue')

const routes = [
  {
    path: '/:identity_id',
    name: 'transactions',
    component: Transactions,
    children: [
      {
        path: '/:identity_id/views/:view_id',
        name: 'view',
        component: About
      },
      {
        path: '/:identity_id/transactions/:transaction_id',
        name: 'transaction',
        component: Transaction
      },
      {
        path: '/:identity_id/about',
        name: 'about',
        component: About
      },
      {
        path: '/:identity_id/feedback',
        name: 'feedback',
        component: Feedback
      },
      {
        path: '/:identity_id/sources',
        name: 'sources',
        component: Sources
      },
      {
        path: '/:identity_id/sources/:source_id/edit',
        name: 'sourceEdit',
        component: SourceEdit
      },
      {
        path: '/:identity_id/rules',
        name: 'rules',
        component: Rules
      },
      {
        path: '/:identity_id/rules/:rule_id/edit',
        name: 'ruleEdit',
        component: RuleEdit
      },
      {
        path: '/:identity_id/staged/new',
        name: 'stagedNew',
        component: StagedEdit
      },
      {
        path: '/:identity_id/staged/:staged_id/edit',
        name: 'stagedEdit',
        component: StagedEdit
      },
      {
        path: '/:identity_id/scenarios',
        name: 'scenarios',
        component: Scenarios
      },
      {
        path: '/:identity_id/settings',
        name: 'settings',
        component: Settings
      },
      {
        path: '/:identity_id/export',
        name: 'export',
        component: Export
      }
    ]
  }, {
    path: '/:catch(.*)',
    name: 'welcome',
    component: Transactions
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export {
  router,
  routes
}
